import { useCallback, useEffect, useState, useMemo } from 'react';
import getCardPhotoUrl from '@alltrails/core/utils/getCardPhotoUrl';

const useCardPhotos = (id: number, photoCount: number) => {
  const [photos, setPhotos] = useState<string[]>([]);
  const [photosLoaded, setPhotosLoaded] = useState(false);

  useEffect(() => {
    const initialPhoto = getCardPhotoUrl({ cardType: 'maps', id, index: 0, size: '1080x700' });
    let fillerPhotos: string[] = [];
    if (photoCount > 1) {
      fillerPhotos = Array(photoCount - 1).fill('') as string[];
    }
    setPhotos([initialPhoto, ...fillerPhotos]);
    setPhotosLoaded(false);
  }, [id, photoCount]);

  const loadPhotos = useCallback(() => {
    if (!photosLoaded) {
      setPhotosLoaded(true);

      const urls = photos.map((_, index) => {
        const url = getCardPhotoUrl({ cardType: 'maps', id, index, size: '1080x700' });
        // pre-load images by browser
        try {
          new Image().src = url;
        } catch {
          // silently catch
        }
        return url;
      });

      setPhotos(urls);
    }
  }, [id, photos, photosLoaded]);

  return useMemo(() => ({ photos, loadPhotos }), [photos, loadPhotos]);
};

export default useCardPhotos;
